import React, { ReactNode } from 'react';

import { Heading } from '../../Heading/Heading';
import { Text } from '../../Text/Text';

interface CatchInfoCardProps {
  iconText?: string;
  bottomText?: string;
  iconComponent: ReactNode;
}

export const CatchInfoCard = ({ iconText, bottomText, iconComponent }: CatchInfoCardProps) => {
  return (
    <div className="bg-lake-fog rounded-md p-2" data-testid="catch-info-card">
      <header className="mx-auto mb-2 flex w-fit items-center">
        <div className={iconText ? 'mr-1' : undefined}>{iconComponent}</div>
        {!!iconText && (
          <Heading as="h3" variant="2xs">
            {iconText}
          </Heading>
        )}
      </header>
      {!!bottomText && (
        <Text className="text-trench m-0 text-center" variant="sm">
          {bottomText}
        </Text>
      )}
    </div>
  );
};
